import React, { Component } from 'react';
import { connect } from 'react-redux';
import io from 'socket.io-client';
import { lighten } from 'polished';

import Icon from '../../components/uielements/icon';
import appActions from '../../redux/app/actions';
import themeActions from "../../redux/themeSwitcher/actions";
import actions from '../../redux/notifications/actions';
import { AppHolder, Toolbar, IconButtons, TopbarComponents, Bell } from './style';
import SecondarySidebar from "../SecondarySidebar";
import SidebarNotification from "./sidebarNotification";
import TopbarUser from './topbarUser';
import { getApiUrl } from '../../settings';
import { createMuiTheme } from '@material-ui/core';
import { MuiThemeProvider } from 'material-ui/styles';
const { toggleCollapsed } = appActions;
const { switchActivation } = themeActions;

const url = `${getApiUrl.apiUrl}:8080`;
let socket = null;

const theme = createMuiTheme({
	overrides: {
		MuiBadge: {
			badge: {
				border: '2px solid white',
				top: '-5px',
				right:' 4px',
				width: '27px',
				height: '27px',
				transform: 'unset',
				borderRadius: '50%',
				transformOrigin: 'unset',
			}
		}
	}
})

class Topbar extends Component {
	constructor(props) {
		super(props);
		this.state = {
			opening: false,
		}
	}

	componentDidMount() {
		this.props.doGetNotifications();
		this.props.doGetCompulsoryNotifications(0);
	}
	
	startConnection(landlordHash) {
		socket = io(url, {
			query: { hash: landlordHash },
		})
		socket.on('connect', () => {
			console.log('connected!');
		});
		socket.on('notification', data => {
			if (data) {
				this.props.doAddNotification(data);
			}
		})
	}
	
	componentDidUpdate(prevProps) {
		const { userData } = this.props;
		const prevUserData = prevProps.userData;
		// Waiting until we have the LL hash
		if (!this.state.opening && userData.extended && userData.extended.landlordHash
			&& (!prevUserData.extended)) {
				this.startConnection(userData.extended.landlordHash);
		}
		if (this.props.untouchedNotificationCount !== prevProps.untouchedNotificationCount) {
			const count = `${this.props.untouchedNotificationCount > 99 ? `(99+) ` : `(${this.props.untouchedNotificationCount})`}`;
			document.title = `${this.props.untouchedNotificationCount > 0 ? `${count} ` : ''}RentalStep`;
		}
	}

	render() {
    const {
			toggleCollapsed,
			locale,
			url,
			customizedTheme,
			userData,
			switchActivation,
			unactionedNotifications,
			actionedNotifications,
			totalActioned,
			totalUnactioned,
			untouchedNotificationCount,
			loadingNotifications,
		} = this.props;
		const propsTopbar = { locale, url, userData };
    const stripes = `
      repeating-linear-gradient(
        -45deg,
        ${customizedTheme.backgroundColor},
        ${customizedTheme.backgroundColor} 10px,
        ${lighten(0.1, customizedTheme.backgroundColor)} 10px,
        ${lighten(0.1, customizedTheme.backgroundColor)} 20px
      )
    `;
    const background = (process.env.REACT_APP_ENV === 'prod' || process.env.REACT_APP_BUILD_STATUS === 'local') ? customizedTheme.backgroundColor : stripes;
		return (
      <AppHolder style={{ background: background }}>
				<Toolbar
					style={{
						paddingLeft: '30px',
						minHeight: '64px',
						background: customizedTheme.topbarTheme,
					}}
				>
					<IconButtons
						id="topbarCollapsed"
						aria-label="open drawer"
						onClick={toggleCollapsed}
						className="right"
					>
						<Icon>menu</Icon>
					</IconButtons>

					<TopbarComponents>
						<ul className="topbarItems">
              <li className="topbarNotification">
                <MuiThemeProvider theme={theme}>
									<Bell
										onClick={() => {
											switchActivation("notification");
											this.props.doSeeAllNotifications();
										}}
										badgeContent={untouchedNotificationCount < 100 ? untouchedNotificationCount : '99+'}
										color="secondary"
										invisible={untouchedNotificationCount <= 0}
									>
										<Icon
											onClick={() => switchActivation("notification")}
											style={{ fontSize: '35px' }}
										>
											{untouchedNotificationCount > 0 || (unactionedNotifications && unactionedNotifications.length > 0)  ? `notifications` : `notifications_none`}
										</Icon>
									</Bell>
                  <SecondarySidebar
                    InnerComponent={SidebarNotification}
										currentActiveKey="notification"
										unactionedNotifications={unactionedNotifications}
										actionedNotifications={actionedNotifications}
										totalActioned={totalActioned}
										totalUnactioned={totalUnactioned}
										loadActioned={this.props.doLoadActioned}
										loadUnactioned={this.props.doLoadUnactioned}
										loadingActioned={this.props.loadingActioned}
										loadingUnactioned={this.props.loadingUnactioned}
										loadingNotifications={loadingNotifications}
										compulsoryNotifications={this.props.compulsoryNotifications}
										totalCompulsory={this.props.totalCompulsory}
										loadingCompulsory={this.props.loadingCompulsory}
										loadCompulsory={this.props.doLoadCompulsoryNotifications}
										loadingMoreCompulsory={this.props.loadingMoreCompulsory}
                    {...propsTopbar}
                  />
                </MuiThemeProvider>
              </li>
							<li className="topbarUser">
								<TopbarUser {...propsTopbar} />
							</li>
						</ul>
					</TopbarComponents>
				</Toolbar>
			</AppHolder>
		);
	}
}

const { doGetNotifications, doAddNotification, doLoadActioned, doLoadUnactioned, doSeeAllNotifications, doGetCompulsoryNotifications, doLoadCompulsoryNotifications } = actions;

export default connect(
	state => ({
		...state.App,
		locale: state.LanguageSwitcher.language.locale,
		customizedTheme: state.ThemeSwitcher.topbarTheme,
		unactionedNotifications: state.Notifications.get('unactionedNotifications'),
		actionedNotifications: state.Notifications.get('actionedNotifications'),
		untouchedNotificationCount: state.Notifications.get('untouchedNotificationCount'),
		totalActioned: state.Notifications.get('totalActioned'),
		totalUnactioned: state.Notifications.get('totalUnactioned'),
		loadingActioned: state.Notifications.get('loadingActioned'),
		loadingUnactioned: state.Notifications.get('loadingUnactioned'),
		loadingNotifications: state.Notifications.get('loadingNotifications'),
		compulsoryNotifications: state.Notifications.get('compulsoryNotifications'),
		totalCompulsory: state.Notifications.get('totalCompulsory'),
		loadingCompulsory: state.Notifications.get('loadingCompulsory'),
		loadingMoreCompulsory: state.Notifications.get('loadingMoreCompulsory'),
	}),
  { toggleCollapsed, switchActivation, doGetNotifications, doAddNotification, doLoadActioned, doLoadUnactioned, doSeeAllNotifications, doGetCompulsoryNotifications, doLoadCompulsoryNotifications }
)(Topbar);



// WEBPACK FOOTER //
// ./src/containers/Topbar/index.js